import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=3c81f006&scoped=true&lang=pug&"
import script from "./SettingsView.vue?vue&type=script&lang=ts&"
export * from "./SettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81f006",
  null
  
)

export default component.exports